import { useMemo } from 'react';
import { useSkinStyles } from './useSkinStyles';
import { REOFFERED_COLOR_SKIN_STYLES } from '../styles/components/reofferedColor';

export const useSkinnedReofferedColor = () => {
  const colors = useSkinStyles(REOFFERED_COLOR_SKIN_STYLES);

  return useMemo(
    () =>
      <T>(currentValue: T, previousValue: T) => {
        if (previousValue === undefined || previousValue === null) {
          return { color: colors.unchanged, changed: false };
        }

        let isEqual: boolean;
        let isLessThan: boolean;

        if (Array.isArray(currentValue) && Array.isArray(previousValue)) {
          if (currentValue.length !== previousValue.length) {
            isEqual = false;
            isLessThan = currentValue.length < previousValue.length;
          } else {
            const prev = previousValue as Array<{ value: number }>;
            isEqual = currentValue.every(({ value }, index) => value === prev[index].value);
            isLessThan = currentValue.some(({ value }, index) => value < prev[index].value);
          }
        } else {
          isEqual = currentValue === previousValue;
          isLessThan = currentValue < previousValue;
        }

        if (isEqual) return { color: colors.unchanged, changed: false };
        if (isLessThan) return { color: colors.decreased, changed: true };
        return { color: colors.increased, changed: true };
      },
    [colors]
  );
};
